// Kullanıcı ID'sine göre deterministik 3-renk gradyantı seç. Ağım sayfası
// (Dashboard) ve profil banner'ı arasında tutarlı kullanıcı imzası üretir.

export const USER_GRADIENTS = [
  ['#a752af', '#f43f5e', '#8b5cf6'],
  ['#2563eb', '#7c3aed', '#06b6d4'],
  ['#f43f5e', '#f97316', '#eab308'],
  ['#06b6d4', '#22c55e', '#a752af'],
  ['#7c3aed', '#ec4899', '#f97316'],
  ['#0ea5e9', '#8b5cf6', '#f43f5e'],
  ['#10b981', '#06b6d4', '#7c3aed'],
  ['#f59e0b', '#ef4444', '#ec4899'],
];

export function getUserGradient(id) {
  let hash = 0;
  for (let i = 0; i < (id || '').length; i++) {
    hash = ((hash << 5) - hash) + id.charCodeAt(i);
  }
  return USER_GRADIENTS[Math.abs(hash) % USER_GRADIENTS.length];
}
